import React from 'react';
import { Section } from './Section';
import { VolumeCard } from './VolumeCard';
import { volumes } from '../data/volumes';
export function Volumes() {
  return <Section tone="canvas" title="What's inside Obesity Clinical Blueprint™?" subtitle="Six practical clinical volumes for a more structured approach to adult obesity care." cta="Yes, I want all six volumes" ctaNote="Instant Digital Access · One-Time Payment of $27 USD" data-id="element-283" data-mp="1lx4pobve4v78">
      <div className="mx-auto max-w-4xl space-y-6 md:space-y-8" data-id="element-284" data-mp="24u5tvuh4era4">
        {volumes.map(volume => <VolumeCard key={volume.numeral} volume={volume} data-id="element-285" data-mp="1qud7ucgjgz8h" />)}
      </div>

      <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-286" data-mp="1qwpn2huwwvhu">
        <h3 className="font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-287" data-mp="1vs4yl35g6fb3">
          Six volumes. <span className="text-brand" data-id="element-288" data-mp="fdmwyg167j8j">One organized clinical reference system.</span>
        </h3>
        <p className="mt-5 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-289" data-mp="kfvt1l9cb1ev">
          Rather than searching through scattered notes and repeatedly rebuilding your own resources, you can navigate
          directly to the subject you need to review. Each volume has a defined purpose. Each worksheet supports a
          specific organizational task. And the visual framework connects every part of the system.
        </p>
      </div>
    </Section>;
}